import SignatoryGroupRepository from "../domain/data/SignatoryGroupRepository";
import SignatoryGroup from "../domain/entities/SignatoryGroup";
import User from "../domain/entities/User";
import { signatoryGroups } from "./InitData";
import { v4 as uuidv4 } from "uuid";

export default class MockSignatoryGroupRepository
  implements SignatoryGroupRepository
{
  private static signatoryGroups: SignatoryGroup[] = signatoryGroups;

  async getSignatoryGroups(user: User): Promise<SignatoryGroup[]> {
    return MockSignatoryGroupRepository.signatoryGroups;
  }
  async saveSignatoryGroup(
    user: User,
    signatoryGroup: SignatoryGroup
  ): Promise<SignatoryGroup> {
    if (!signatoryGroup.id) {
      signatoryGroup.id = uuidv4();
      MockSignatoryGroupRepository.signatoryGroups.push(signatoryGroup);
      return signatoryGroup;
    } else {
      const record = MockSignatoryGroupRepository.signatoryGroups.find(
        (record) => record.id === signatoryGroup.id
      );
      if (record) {
        record.name = signatoryGroup.name;
        record.description = signatoryGroup.description;
        record.signatories = signatoryGroup.signatories;
      }
      return record as SignatoryGroup;
    }
  }

  async deleteSignatoryGroup(
    user: User,
    signatoryGroup: SignatoryGroup
  ): Promise<boolean> {
    const record = MockSignatoryGroupRepository.signatoryGroups.find(
      (record) => record.id === signatoryGroup.id
    );
    if (record) {
      MockSignatoryGroupRepository.signatoryGroups =
        MockSignatoryGroupRepository.signatoryGroups.filter(
          (record) => record.id !== signatoryGroup.id
        );
      return true;
    }
    return false;
  }
  async saveSignatoryGroupAsync(
    user: User,
    signatoryGroup: SignatoryGroup
  ): Promise<void> {
    throw new Error("Method not implemented.");
  }
}
